<template>
  <div class="d-flex"
       :class="{ 'filter-activated': active }">
    <slot></slot>
    <ButtonIconOnly v-if="active"
                    :title="tr('common.RESET')"
                    :size="size"
                    :variant="BootstrapVariant.SECONDARY"
                    class="reset-button"
                    icon-name="cross2"
                    @click="resetFilter"></ButtonIconOnly>
  </div>
</template>

<script>
  import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';
  import translator from '~/zf/frontend/common/mixins/translator';
  import ButtonIconOnly from '../../layout/ButtonIconOnly.vue';

  export default {
    name: 'ExternalFilterResetWrapper',
    compatConfig: {
      MODE: 3,
    },
    components: { ButtonIconOnly },
    mixins: [translator],
    props: {
      active: {
        type: Boolean,
        required: true,
      },
      size: {
        type: String,
        default: BootstrapVariant.MEDIUM,
      },
    },
    emits: ['reset-filter'],
    data() {
      return {
        BootstrapVariant,
      };
    },
    methods: {
      resetFilter() {
        return this.$emit('reset-filter');
      },
    },
  };
</script>

<style scoped lang="scss">
  .filter-activated {
    :deep(.multiselect__content-wrapper) {
      width: calc(100% + 37px);
    }

    :deep(button.btn.dropdown-toggle) {
      border-right-width: 0;
    }

    .reset-button {
      border-left-width: 0;

      &.btn-sm {
        width: 24px;
      }
    }
  }
</style>
